import { FormColumns } from 'common-front/src/components/form/formColumns';
import { HorizontalSpacerSeparator } from 'common-front/src/designSystem/components/separator';
import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { ToggleText } from 'common-front/src/designSystem/form/toggle';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Flex } from 'common/src/designSystem/components/flex';
import { Campaign, CustomDocument, SegmentCustomFieldFragment } from 'common/src/generated/types';
import { ICreateUpdateDelegationValues } from 'common/src/input/delegationInput';
import * as React from 'react';
import { CreateDelegationColumns } from './createDelegationColumns';

interface ICreateDelegationDelegationsSpaceProps {
    campaigns: Array<Pick<Campaign, 'id' | 'name'>>;
    customDocuments: Array<Pick<CustomDocument, 'slug' | 'name'>>;
    customFields: SegmentCustomFieldFragment[];
    values: ICreateUpdateDelegationValues;

    change(name: string, value: any): void;
}

export const CreateDelegationDelegationsSpace = (props: ICreateDelegationDelegationsSpaceProps) => {
    const { translate } = useHeavent();

    return (
        <Flex direction="column">
            <FormColumns title={translate('liste_des_colon_20101')}>
                <CreateDelegationColumns
                    change={props.change}
                    customFields={props.customFields}
                    values={props.values}
                />
            </FormColumns>

            <HorizontalSpacerSeparator height="5" />

            <FormColumns title={translate('droits_des_resp_01552')}>
                <Flex direction="column" gap="3" width={1}>
                    <ToggleText name="delegation.showFormLinkInDelegationSpace">
                        {translate('afficher_le_lie_05841')}
                    </ToggleText>

                    <ToggleText name="delegation.canLeadersAddMembers">
                        {translate('CanLeadersAddMembers')}
                    </ToggleText>

                    <ToggleText name="delegation.canLeadersEditMembers">
                        {translate('CanLeadersEditMembers')}
                    </ToggleText>

                    <ToggleText name="delegation.canLeadersDeleteMembers">
                        {translate('CanLeadersDeleteMembers')}
                    </ToggleText>

                    <ToggleText name="delegation.canLeadersEditColumns">
                        {translate('CanLeadersEditColumns')}
                    </ToggleText>

                    <ToggleText name="delegation.canLeadersEditCustomFields">
                        {translate('CanLeadersEditCustomFields')}
                    </ToggleText>
                </Flex>
            </FormColumns>

            <HorizontalSpacerSeparator height="5" />

            <FormColumns title={translate('communication_05277')}>
                <Flex direction="column" gap="6" width={1}>
                    <RichSelect
                        isSearchVisible={true}
                        isSelectAllVisible={true}
                        label={translate('liste_des_campa_21201')}
                        multiple={true}
                        name="delegation.campaignsIds"
                    >
                        {props.campaigns.map((campaign) => (
                            <option key={campaign.id} value={campaign.id}>
                                {campaign.name}
                            </option>
                        ))}
                    </RichSelect>

                    <RichSelect
                        isSearchVisible={true}
                        isSelectAllVisible={true}
                        label={translate('liste_des_docum_18767')}
                        multiple={true}
                        name="delegation.customDocumentsSlugs"
                    >
                        {props.customDocuments.map((customDocument) => (
                            <option key={customDocument.slug} value={customDocument.slug}>
                                {customDocument.name}
                            </option>
                        ))}
                    </RichSelect>
                </Flex>
            </FormColumns>
        </Flex>
    );
};
